export default __webpack_public_path__ + "static/media/Aries.23a9e070.svg";